import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableVmpFragment = { readonly __typename?: 'SyncableVmp', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly snomedId?: string | null, readonly formId: string, readonly categoryId?: string | null, readonly legacyMedicationId?: string | null, readonly productType: Types.ProductType, readonly vtmId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncVmpPullQueryVariables = Types.Exact<{
  input: Types.PullVmpInput;
}>;


export type SyncVmpPullQuery = { readonly __typename?: 'Query', readonly pullVmp: { readonly __typename?: 'PullVmpResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableVmp', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly snomedId?: string | null, readonly formId: string, readonly categoryId?: string | null, readonly legacyMedicationId?: string | null, readonly productType: Types.ProductType, readonly vtmId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableVmpFragmentDoc = gql`
    fragment WholeSyncableVmp on SyncableVmp {
  id
  title
  keywords
  snomedId
  formId
  categoryId
  legacyMedicationId
  productType
  vtmId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncVmpPullDocument = gql`
    query SyncVmpPull($input: PullVmpInput!) {
  pullVmp(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableVmp
    }
  }
}
    ${WholeSyncableVmpFragmentDoc}`;

/**
 * __useSyncVmpPullQuery__
 *
 * To run a query within a React component, call `useSyncVmpPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncVmpPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncVmpPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncVmpPullQuery(baseOptions: Apollo.QueryHookOptions<SyncVmpPullQuery, SyncVmpPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncVmpPullQuery, SyncVmpPullQueryVariables>(SyncVmpPullDocument, options);
      }
export function useSyncVmpPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncVmpPullQuery, SyncVmpPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncVmpPullQuery, SyncVmpPullQueryVariables>(SyncVmpPullDocument, options);
        }
export type SyncVmpPullQueryHookResult = ReturnType<typeof useSyncVmpPullQuery>;
export type SyncVmpPullLazyQueryHookResult = ReturnType<typeof useSyncVmpPullLazyQuery>;
export type SyncVmpPullQueryResult = Apollo.QueryResult<SyncVmpPullQuery, SyncVmpPullQueryVariables>;